import React, { useEffect, useState } from 'react';
import Checkout from '../Checkout';
import getCurrentUser from '../common/GetCurrentUser';
import { sendRequest } from '../../ApiRequest';
import { BASE_URL } from '../../URL/constants';

const Login = ({ isOpen, onClose, onLoginSuccess, customerData }) => {
  const { isLoggedIn, currentUser, logoutUser, loginUser } = getCurrentUser();

  const [sameAsBilling, setSameAsBilling] = useState(true);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    billingAddressId: "",
    billingAddressLine1: "",
    billingAddressLine2: "",
    billingCity: "",
    billingPincode: "",
    billingState: "Madhya Pradesh",
    billingCountry: "India",
    shippingAddressId: "",
    shippingAddressLine1: "",
    shippingAddressLine2: "",
    shippingCity: "",
    shippingPincode: "",
    shippingState: "Madhya Pradesh",
    shippingCountry: "India",
    shippingPhone: "",
    shippingGstin: "",
    gstNumber: "",
    companyName: "",
  });

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("blur-background");
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove("blur-background");
      document.body.style.overflow = 'unset';
    }
  
    return () => {
      document.body.classList.remove("blur-background");
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  

  useEffect(() => {
    if (customerData) {
      const billingAddress = customerData?.addresses?.find(addr => addr?.address_type === "billing") || null;
      const shippingAddress = customerData?.addresses?.find(addr => addr?.address_type === "shipping") || null;

      setFormData({
        firstName: customerData?.first_name || "",
        lastName: customerData?.last_name || "",
        email: customerData?.email || "",
        phone: customerData?.phone || "",
        billingAddressId: billingAddress?.id || "",
        billingAddressLine1: billingAddress?.address_line_1 || "",
        billingAddressLine2: billingAddress?.address_line_2 || "",
        billingCity: billingAddress?.city || "",
        billingPincode: billingAddress?.postal_code || "",
        billingState: billingAddress?.state || "Madhya Pradesh",
        billingCountry: billingAddress?.country || "India",
        shippingAddressId: shippingAddress?.id || "",
        shippingAddressLine1: shippingAddress?.address_line_1 || "",
        shippingAddressLine2: shippingAddress?.address_line_2 || "",
        shippingCity: shippingAddress?.city || "",
        shippingPincode: shippingAddress?.postal_code || "",
        shippingState: shippingAddress?.state || "Madhya Pradesh",
        shippingCountry: shippingAddress?.country || "India",
        shippingPhone: shippingAddress?.phone || "",
        shippingGstin: shippingAddress?.gstin || "",
        gstNumber: customerData?.gst_number || "",
        companyName: customerData?.company_name || "",
      });
    }
  }, [customerData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const form = new FormData(e.target);
    const formValues = Object.fromEntries(form.entries());

    const payload = {
      customer: {
        id: customerData?.id || null,
        name: `${formValues.firstName} ${formValues.lastName}`,
        phone: formValues.phone,
        email: formValues.email,
        first_name: formValues.firstName,
        last_name: formValues.lastName,
        gst_number: formValues.gstNumber || null,
        company_name: formValues.companyName || null,
        pan_number: null,
        addresses_attributes: [
          {
            id: formData.billingAddressId || null,
            address_line_1: formValues.billingAddressLine1,
            address_line_2: formValues.billingAddressLine2,
            city: formValues.billingCity,
            postal_code: formValues.billingPincode,
            country: formValues.billingCountry,
            state: formValues.billingState,
            address_type: "billing",
          },
          {
            id: formData.shippingAddressId || null,
            address_line_1: sameAsBilling ? formValues.billingAddressLine1 : formValues.shippingAddressLine1,
            address_line_2: sameAsBilling ? formValues.billingAddressLine2 : formValues.shippingAddressLine2,
            city: sameAsBilling ? formValues.billingCity : formValues.shippingCity,
            postal_code: sameAsBilling ? formValues.billingPincode : formValues.shippingPincode,
            country: sameAsBilling ? formValues.billingCountry : formValues.shippingCountry,
            state: sameAsBilling ? formValues.billingState : formValues.shippingState,
            address_type: "shipping",
            phone: sameAsBilling ? formValues.phone : formValues.shippingPhone || formValues.phone,
            shipping_gstin: sameAsBilling ? "" : formValues.shippingGstin || "",
          },
        ],
      },
    };

    try {
      const response = await sendRequest(
        'POST',
        `${BASE_URL}/v1/public_site/customers/create`,
        null,
        { payload },
        { Authorization: currentUser.data.token }
      );

      console.log("Customer created successfully:", response);
      onLoginSuccess();
    } catch (error) {
      console.error("Error creating customer:", error);
      alert("Failed to create customer. Please try again.");
    }
  };

  const handlePaymentSuccess = () => {
    onClose(); // Close the form after successful payment
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div className="modal fade show d-block" id="loginModal" tabIndex="-1" style={{ zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content shadow rounded">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">Customer Details</h5>
              <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
              <form onSubmit={handleLogin} className="px-2">
                <div className="p-3 border rounded mb-4 bg-light">
                  <h6 className="mb-3">Contact Information</h6>
                  <div className="row">
                    {[
                      { label: "First Name", name: "firstName", type: "text" },
                      { label: "Last Name", name: "lastName", type: "text" },
                      { label: "Email", name: "email", type: "email" },
                      { label: "Phone", name: "phone", type: "number" },
                    ].map(({ label, name, type }) => (
                      <div className="col-md-6 mb-3" key={name}>
                        <label>{label}</label>
                        <input type={type} name={name} className="form-control" value={formData[name]} onChange={handleChange} required />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="p-3 border rounded mb-4 bg-light">
                  <h6 className="mb-3">Billing Address</h6>
                  <div className="row">
                    {[
                      { label: "Address Line 1", name: "billingAddressLine1" },
                      { label: "Address Line 2", name: "billingAddressLine2" },
                      { label: "City", name: "billingCity" },
                      { label: "Pincode", name: "billingPincode" },
                    ].map(({ label, name }) => (
                      <div className="col-md-6 mb-3" key={name}>
                        <label>{label}</label>
                        <input type="text" name={name} className="form-control" value={formData[name]} onChange={handleChange} required />
                      </div>
                    ))}

                    <div className="col-md-6 mb-3">
                      <label>State</label>
                      <select name="billingState" className="form-control" value={formData.billingState} onChange={handleChange} required>
                        <option>Madhya Pradesh</option>
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Country</label>
                      <select name="billingCountry" className="form-control" value={formData.billingCountry} onChange={handleChange} required>
                        <option>India</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-check mb-3">
                  <input type="checkbox" className="form-check-input" id="sameAddress" checked={sameAsBilling} onChange={() => setSameAsBilling(!sameAsBilling)} />
                  <label className="form-check-label" htmlFor="sameAddress">Billing address same as shipping address</label>
                </div>

                {!sameAsBilling && (
                  <div className="p-3 border rounded mb-4 bg-light">
                    <h6 className="mb-3">Shipping Address</h6>
                    <div className="row">
                      {[
                        { label: "Address Line 1", name: "shippingAddressLine1" },
                        { label: "Address Line 2", name: "shippingAddressLine2" },
                        { label: "City", name: "shippingCity" },
                        { label: "Pincode", name: "shippingPincode" },
                      ].map(({ label, name }) => (
                        <div className="col-md-6 mb-3" key={name}>
                          <label>{label}</label>
                          <input type="text" name={name} className="form-control" value={formData[name]} onChange={handleChange} required />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="mt-4">
                  <Checkout formData={formData} onPaymentSuccess={handlePaymentSuccess} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
